import {
  CollectionEntryOptions,
  createCollectionEntryExtension,
} from '@spotify/plugin-confidence-collections-react';

import { flagsPlugin } from '../plugin';

export const FlagCollectionEntryExtension = flagsPlugin.provide(
  createCollectionEntryExtension({
    id: 'flag',
    resourceType: 'Flag',
    predicate: ({ resource }: CollectionEntryOptions) =>
      '__typename' in resource && resource.__typename === 'FlagsAdminV1Flag',
    render: () => null,
  }),
);
